<template>
    <div class="column-layout">
        <swb-query-sort-area :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
        <div v-if="checkBox" class="table-layout">
            <el-table ref="multipleTable" :data="devcInspectFlowList" border style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column v-if="checkBox" type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="name" label="名称" align="left" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="feature" label="流程特点" align="left" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="creatorName" label="创建人" align="left" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="table-layout" v-else>
            <el-table ref="multipleTable" :data="devcInspectFlowList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                <el-table-column width="55">
                    <template slot-scope="rows">
                        <div class="copy-radio" :class="{'circle' : checkFlowInfo!= null && checkFlowInfo.id == rows.row.id}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="名称" align="left" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="feature" label="流程特点" align="left" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="creatorName" label="创建人" align="left" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import rentServcApi from '../../api/rentServc'

    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "valueType": "String",
            "code": "name",
            "label": "名称",
            "basic": true,
            "hidden": false
        }, {
            "type": "Date2",
            "label": "创建时间",
            "code": "createTime",
            "basic": true,
            "valueType": "String"
        }],
        "sortFields": []
    };

    export default {
        name: 'swb-devc-inspect-flow-for-select',
        desc: '设备检验流程-选择',
        props: {
            checkBox: {
                type: Boolean,
                default: true
            },
            filterItems: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            checkedFlowList: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                checkedTblRefId: 'multipleTable',
                checkedDelay: 100,
                checkedIniting: false,
                //
                devcInspectFlowList: [],
                selectFlowList: [],
                selectFlowIds: [],
                checkFlowInfo: null,
                //
                //排序、搜索
                queryConfig: searchConfigData,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.selectFlowList = Utils.merge([], this.checkedFlowList);
            //
            this.getDevcInspectFlowList();
        },
        methods: {
            queryHandler(queryModel) {
                if(this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.pageNumber = 1;
                this.queryModel = queryModel;
                //
                this.getDevcInspectFlowList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                if(this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.pageNumber = val;
                this.getDevcInspectFlowList();
            },
            getDevcInspectFlowList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.disabled = false;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let theLoad = MsgBox.loading();
                rentServcApi.getDevcInspectFlowPageList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let data = result.data;
                        self.devcInspectFlowList = data.rows || [];
                        //
                        self.totalCount = result.data.pagination.totalCount;
                        //
                        // 处理回显
                        setTimeout(function () {
                            self.restoreSelRows(self.devcInspectFlowList, self.checkedTblRefId, 'id');
                        }, self.checkedDelay);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            restoreSelRows(dataRows, tblRefId, idProp){
                let self = this;
                self.checkedIniting = true;
                idProp = idProp || "id";
                let allIds = dataRows.pluck(idProp);
                let selectFlowIds = self.selectFlowList.pluck("id");
                let selIds = Utils.compareArrays(allIds, selectFlowIds)["same"];
                selIds.forEach(function (id) {
                    self.toggleListRowById(dataRows, tblRefId, idProp, id);
                });
                //
                self.checkedIniting = false
            },
            toggleListRowById(dataRows, tblRefId, idProp, idVal){
                let self = this;
                idProp = idProp || "id";
                let refTbl = self.$refs[tblRefId];
                let theRow = dataRows.find(function (row, idx) {
                    return row[idProp] == idVal;
                });
                if(theRow != null) {
                    refTbl.toggleRowSelection(theRow);
                }
            },
            // 多选
            handleSelectionChange: function (selRows) {
                let self = this;
                if(self.checkedIniting) {
                    return;
                }
                let selectFlowIds = self.selectFlowList.pluck("id");
                let selectIds = Utils.merge([], selectFlowIds);
                let selectFlowList = Utils.merge([], this.selectFlowList);
                //
                let allIds = self.devcInspectFlowList.pluck("id");
                let selIds = selRows.pluck("id");
                selIds.forEach(function (id, index) {
                    self.addCheckId(id, selRows[index], selectIds, selectFlowList);
                });
                let lesIds = Utils.compareArrays(selIds, allIds)["less"];
                lesIds.forEach(function (id, index) {
                    self.delCheckId(id, selectIds, selectFlowList);
                });
                //
                this.selectFlowList = selectFlowList;
            },
            addCheckId: function (id, val, checkedIds, checkedList) {
                if(!checkedIds.contains(id)) {
                    checkedIds.add(id);
                    checkedList.add(val);
                    return id;
                }
                this.$emit("handle-change", checkedList);
                return null;
            },
            delCheckId: function (id, checkedIds, checkedList) {
                if(checkedIds.contains(id)) {
                    for(let i = 0; i < checkedList.length; i++) {
                        let checkedCom = checkedList[i];
                        if(checkedCom.id == id) {
                            checkedList.splice(i, 1);
                        }
                    }
                    checkedIds.remove(id);
                    return id;
                }
                this.$emit("handle-change", checkedList);
                return null;
            },
            // 单选
            handleCurrentChange: function (val) {
                this.checkFlowInfo = Utils.merge({}, val);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let checkBox = self.checkBox;
                if(checkBox) {
                    let selectFlowList = self.selectFlowList;
                    if(selectFlowList != null && selectFlowList.length > 0) {
                        result.type = "info";
                        result.data = selectFlowList;
                    } else {
                        result.type = 'warn';
                        result.message = '至少选择一个检验流程！';
                    }
                } else {
                    let flowInfo = self.checkFlowInfo;
                    if(flowInfo != null) {
                        result.type = "info";
                        result.data = flowInfo;
                    } else {
                        result.type = 'warn';
                        result.message = '请选择检验流程！';
                    }
                }
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/rentServc/DevcInspectFlowListForSelect.vue